import React from 'react';

export default [
  {
    text: (
      <>
        <p>
          FEITOSA, Ankilma do Nascimento Andrade. Reabilitação nas principais alterações neurofuncionais de pacientes com condições pós-covid. In: UNIVERSIDADE ABERTA DO SUS. UNIVERSIDADE FEDERAL DO MARANHÃO.<strong> Reabilitação do paciente com condições pós-covid. Reabilitação neurofuncional do paciente com condições pós-covid</strong>. São Luís: UNA-SUS; UFMA, 2021.
        </p>
      </>
    ),
  },
];
